/** How a SyNeural engagement progresses (not a universal assessment cycle). */
export const solutionCycle = [
  'Connect knowledge',
  'Define the problem',
  'Develop capability',
  'Support action',
  'Examine outcomes',
  'Improve',
]
